export default __webpack_public_path__ + "static/media/img_top_3.b22ee242.webp";